import Check from "../../../assets/images/100-check.svg";

export const EmailVerification = ({ setStep }) => (
  <>
    <div className="flex-col align-items-center justify-content-center">
      <div className="font-32 bold text-black p-tb-32">Reset your password</div>
    </div>
    <div className="auth-form auth-signup">
      <div className="auth-items">
        <div className="auth-row align-items-center">
          <img src={Check} alt="check" width={32} />
        </div>
        <div className="auth-row font-16 m-t-16 text-center p-lr-15">
          <span>A link to reset your password has been emailed to you.</span>
        </div>
        <div className="auth-row font-16 m-b-24 text-center p-lr-15">
          <span>
            If you haven't received that in 5 minutes, please check your spam or try&nbsp;
            <span className="text-blue pointer">resend</span>.
          </span>
        </div>
        <div className="auth-row">
          <div className="justify-content-center">
            <span onClick={() => setStep("login")} className="pointer">
              Back to log in
            </span>
          </div>
        </div>
      </div>
    </div>
  </>
);
